/**
 * TasksTab - Tasks tab component for the agent drawer
 *
 * Provides real-time task monitoring with auto-refresh for Praetorian users.
 * Re-exports TaskMonitoringTab content adapted for drawer context.
 */

import React from 'react';

import { TaskMonitoringTab } from '@/sections/agents/components/aegis-management/task/TaskMonitoringTab';

interface TasksTabProps {
  taskMonitoring: ReturnType<
    typeof import('@/sections/agents/hooks').useTaskMonitoring
  >;
  expandedTasks: Set<string>;
  setExpandedTasks: React.Dispatch<React.SetStateAction<Set<string>>>;
}

export const TasksTab: React.FC<TasksTabProps> = ({
  taskMonitoring,
  expandedTasks,
  setExpandedTasks,
}) => {
  return (
    <div className="flex h-full flex-col" data-testid="agent-drawer-tasks-tab">
      <TaskMonitoringTab
        taskMonitoring={taskMonitoring}
        expandedTasks={expandedTasks}
        setExpandedTasks={setExpandedTasks}
      />
    </div>
  );
};
